<template>
  <b-row id="quiz-and-answer" class="w-100">
    <b-col>
      <div class="container-draggable">
        <div class="draggable-wrp">
          <draggable
            :componentData="componentData"
            :list="formQuestion"
            :animation="100"
            handle=".handle"
            @start="dragging = true"
            @end="dragging = false"
            item-key="name"
          >
            <div
              class="card-inner list-group-item item"
              v-for="element in formQuestion"
              :key="element.seqQuestion"
            >
              <div class="w-100">
                <quiz-item
                  :formQuestion="element"
                  :active="element.seqQuestion === activeIndex"
                  :optionQuestion="optionQuestion"
                  @onAddChoice="onAddChoice"
                  @onRemoveChoice="onRemoveChoice"
                  @onShowUploadImage="onShowUploadImage"
                  @set-active="activeIndex = $event"
                  @onFormQuestion="onFormQuestion"
                  @onUploadImage="onUploadImage"
                  @onUploadImageChoice="onUploadImageChoice"
                  @onRemoveQuestion="onRemoveQuestion($event, element)"
                  @onDuplicate="onDuplicate($event, element)"
                />
              </div>
            </div>
            <div
              class="btn-group list-group-item"
              role="group"
              aria-label="Basic example"
              key="footer"
            >
              <div class="add-quiz" @click="$emit('addQuestion')">
                <icon-plus />
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import draggable from "vuedraggable";
import QuizItem from "../ItemQuiz.vue";
import IconPlus from "@core/components/svg/common/IconPlus.vue";
import useQuestionAnswer from "../../hooks/useQuestionAnswer";

export default {
  components: { draggable, QuizItem, IconPlus },
  props: {
    formQuestion: {
      type: [Object, Array],
    },
    optionQuestion: { type: Object },
  },
  setup(props) {
    const {
      componentData,
      activeIndex,
      onFormQuestion,
      onUploadImage,
      onShowUploadImage,
      onAddChoice,
      onUploadImageChoice,
      onRemoveChoice,
      onRemoveQuestion,
      onDuplicate,
      onChange,
    } = useQuestionAnswer(props);

    return {
      componentData,
      activeIndex,
      onFormQuestion,
      onUploadImage,
      onShowUploadImage,
      onAddChoice,
      onUploadImageChoice,
      onRemoveChoice,
      onRemoveQuestion,
      onDuplicate,
      onChange,
    };
  },
};
</script>


<style>
#quiz-and-answer .card-inner.list-group-item {
  width: 100%;
  background-color: transparent !important;
  border: none !important;
  padding: unset !important;
  display: flex;
}

#quiz-and-answer .container-draggable {
  padding: 0 120px;
}

#quiz-and-answer .draggable-wrp {
  border-radius: 10px;
}

#quiz-and-answer .bg-white {
  background-color: #fff;
}

#quiz-and-answer .add-quiz {
  width: 45px;
  height: 45px;
  border-radius: 0px 0px 7px 7px;
  background-color: #2f96ef;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
}

#quiz-and-answer .add-quiz > svg {
  fill: #fff;
}

#quiz-and-answer .btn-group.list-group-item {
  background-color: transparent !important;
  border: none !important;
  padding: unset !important;
  display: flex;
  justify-content: center;
}
</style>